import { render, staticRenderFns } from "./PublipostagesAdmin.vue?vue&type=template&id=668d8946&"
import script from "./PublipostagesAdmin.vue?vue&type=script&lang=js&"
export * from "./PublipostagesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PublipostagesAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports